import { useEffect, useState, type ReactNode } from "react";

/**
 * Mounts its children only after the browser goes idle (or a short timeout),
 * so non-critical UI (cart drawer, cookie banner, analytics, below-the-fold
 * widgets) does not compete with first paint, the LCP image or hydration.
 * Rendering is identical once mounted.
 */
export function Deferred({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const mark = () => {
      if (!cancelled) setReady(true);
    };
    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(mark, { timeout: 2000 });
      return () => {
        cancelled = true;
        window.cancelIdleCallback?.(id);
      };
    }
    const t = window.setTimeout(mark, 1200);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
    };
  }, []);

  return ready ? children : null;
}
